<template>
<main-content>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#dedicated_info" role="tab" aria-selected="false">
                            {{ $t('label.gateway-info') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#collective-settings" role="tab" aria-selected="false">
                            {{ $t('label.collective_settings') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
    </kt-panel>
    <kt-panel>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="dedicated_info">
                    <kt-row>
                        <kt-col xs="12" md="6" class="pl-4">
                            <dedicated-info :submit="submit" :status="status" :dedicated="form_data"></dedicated-info>
                        </kt-col>
                        <kt-col xs="12" md="6">
                            <div>
                                <router-link v-if="status === 'setFormData'&& (form_data.psp  === 'novin' || form_data.psp  === 'saman')"
                                             class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square mt-2 mb-2"
                                             :to="{
                                                name: 'dedicated_transactions_report',
                                                params: {hashid},
                                                query: {psp: form_data.psp}
                                             }"

                                >
                                    {{ $t('btn.getTransactionReport') }}
                                </router-link>
                                <router-link v-if="status === 'setFormData' && form_data.psp === 'novin'"
                                             class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square mt-2 mb-2"
                                             :to="{
                                                name: 'dedicated_statements_report',
                                                params: {hashid},
                                                query: {psp: form_data.psp}
                                             }"
                                >
                                    {{ $t('btn.getStatementsReport') }}
                                </router-link>
                            </div>
                            <gateway-statistics></gateway-statistics>
                            <dedicated-setting :status="status" :dedicated="form_data"></dedicated-setting>
                        </kt-col>
                    </kt-row>
                </div>
                <div class="tab-pane" id="collective-settings">
                    <collective-setting :shop_type="1"></collective-setting>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import { dedicatedSetting, dedicatedInfo } from './components'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { dedicatedService } from '@/common/api.service'
import { collectiveSetting } from '../collective/components'
import gatewayStatistics from './components/gateway-statisics'
import StatementsReport from './StatementsReportDedicated'

export default {
    components: {
        mainContent,
        dedicatedSetting,
        dedicatedInfo,
        collectiveSetting,
        'gateway-statistics': gatewayStatistics
    },
    computed: {
        ...mapGetters('dedicated', [
            'form_data', 'status'
        ]),
        form_data: {
            get: function() {
                return this.$store.state.dedicated.form_data
            },
            set: function(value) {
                this.$store.commit('dedicated/setFormData', value)
            }
        }
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('dedicated/find', vm.hashid)
        })
    },
    methods: {
        submit(e) {
            this.form_data.merchant_share_percent = $('#merchant_share_percent').val()
            let form = $('#dedicated_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    merchant_type: {
                        required: true,
                    },
                    birth_crtfct_number: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    birth_crtfct_serial: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    birth_crtfct_series_letter: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    birth_crtfct_series_number: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    gender: {
                        required: function(){
                            return $("#merchant_type").val() == 0;
                        }
                    },
                    com_name_fa: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    com_name_en: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    national_legal_code: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    register_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    register_date: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    commercial_name: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_birth_crtfct_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_birth_crtfct_serial: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_birth_crtfct_series_letter: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_birth_crtfct_series_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    signatory_gender: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_first_name: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_last_name: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_phone_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_telephone_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    technical_agent_email: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    province: {
                        required: true,
                    },
                    city: {
                        required: true,
                    },
                    phone_number: {
                        required: true
                    },
                    ownership_type: {
                        required: true
                    },
                    rental_contract_number: {
                        required: function(){
                            return $("#ownership_type").val() == 1;
                        }
                    },
                    rental_expiry_date: {
                        required: function(){
                            return $("#ownership_type").val() == 1;
                        }
                    },
                    category_code: {
                        required: true,
                    },
                    sheba_number: {
                        required: true
                    },
                    certificate_number: {
                        required: true
                    },
                    certificate_issue_date: {
                        required: true
                    },
                    certificate_expiry_date: {
                        required: true
                    },
                    etrust_certificate_type: {
                        required: true
                    },
                    etrust_certificate_issue_date: {
                        required: true
                    },
                    etrust_certificate_expiry_date: {
                        required: true
                    },
                    website_address: {
                        required: true
                    },
                    callback_address: {
                        required: true
                    },
                    server_ip: {
                        required: true
                    },
                    business_type: {
                        required: true
                    },
                    programming_language: {
                        required: true
                    },
                    email: {
                        required: true
                    },
                    wage: {
                        required: true
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = this.form_data

            dedicatedService.updateFullForm(this.hashid, params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })
        },
    },
}
</script>

<style>
@media (min-width: 768px) {
    #dedicated-info > div > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>